import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { SpinButtonComponent } from '@bmat/spin-button';

import { GraphQLPagination } from './graphql-collection-pagination.interfaces';

@Component({
  selector: 'bm-graphql-pagination',
  templateUrl: 'grahpql-collection-pagination.component.html',
  styleUrls: ['grahpql-collection-pagination.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
/**
 * Angular Component. Displays controls of pagination in tables
 */
export class BMGraphQLPaginationComponent {
  @Input()
  public set pagination(v: GraphQLPagination) {
    if (v) {
      this.currentPage = 1 + Math.floor(v.start / v.limit);
      this.numberPages = Math.ceil(v.total / v.limit);
      this.isFirst = v.start === 0;
      this.isLast = v.length + v.start >= v.total;
    }
  }

  @Output()
  public goToPage = new EventEmitter<number>();

  public numberPages!: number;
  public isFirst!: boolean;
  public isLast!: boolean;
  public currentPage!: number;

  @ViewChild(SpinButtonComponent, { static: false })
  private _spinBtn!: SpinButtonComponent;

  public deltaPage($event: Event, delta: number) {
    $event.preventDefault();
    this.goToPage.emit(this.computeValudDestination(this.currentPage + delta));
  }

  public goToFirst($event: Event) {
    $event.preventDefault();
    this.goToPage.emit(1);
  }

  public goToLast($event: Event) {
    $event.preventDefault();
    this.goToPage.emit(this.numberPages);
  }

  public submit($event: Event) {
    $event.preventDefault();
    if (this._spinBtn && Number.isInteger(this._spinBtn.value)) {
      this.goToPage.emit(this.computeValudDestination(this._spinBtn.value));
    }
  }

  private computeValudDestination(dest: number) {
    return Math.min(Math.max(1, dest), this.numberPages);
  }
}
